export default "__VITE_ASSET__DO9Ju0Pz__"